import { ActionDescriptor } from '../common/commonTypes';
import AppendAttributeForm from './AppendAttributeForm';

const appendAttribute: ActionDescriptor = {
	FormComponent: AppendAttributeForm,
	actionTitle: 'Append',
};

export default appendAttribute;
